import { render, staticRenderFns } from "./AdoptedSocialStudies.vue?vue&type=template&id=1b4492b9&scoped=true&"
import script from "./AdoptedSocialStudies.vue?vue&type=script&lang=js&"
export * from "./AdoptedSocialStudies.vue?vue&type=script&lang=js&"
import style0 from "./AdoptedSocialStudies.vue?vue&type=style&index=0&id=1b4492b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4492b9",
  null
  
)

export default component.exports